<template>
    <div class="container">
        <div class="content">
            <el-card style="width: 100%;">
                <div slot="header" class="clearfix vio-header">
                    <span style="color: #002257;font-size: 20px;">违章处理</span>
                    <!-- <img src="../assets/app.png" alt="" class="imgfont" @mouseover='app(true)' @mouseout="app(false)"> -->
                    <div class="app-download" v-if="showapp">
                        <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:175px;height: 175px;">
                        <img src="../assets/app_sale.png" alt="" style="width:223px;height: 68px;">
                        <!-- <div>扫码立即下载APP</div>
                        <div>首次办理电子眼立减5元</div> -->
                    </div>
                </div>
                <div style="background: #FAFDFF;border: 1px solid #EBEDF7;padding: 20px 30px;">
                    <div class="form-title">
                        处罚判决书编号  <span style="color: #002257;font-size: 20px;margin-left: 10px;">{{orderNumber}}</span>
                    </div>
                    
                    <div class="pay-container">
                        <el-form label-width="125px" class="payform" size="small">
                            <el-form-item label="被处罚人" v-if="payForm&&payForm.name">
                                {{ payForm&&payForm.name}}
                            </el-form-item>
                            <el-form-item label="车牌号码" v-if="payForm&&payForm.car_no">
                                {{payForm&&payForm.car_no}}
                            </el-form-item>
                            <el-form-item label="手机号码">
                                <el-input v-model="phone" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="2小时加急处理" v-if="canUrge">
                                <el-switch v-model="urge" style="margin-top:-8px" @change="urgeChange">
                                </el-switch>
                                <el-popover
                                    placement="bottom-start"
                                    title="提醒"
                                    width="350"
                                    trigger="hover"
                                    content="">
                                    <p style='text-align:left;padding-left:20px;'>
                                        <span style='position:absolute;left:10px;margin-top:2px;color:#fff;line-height:15px;width:15px;height:15px;background:#D8D8D8;border-radius:50%;text-align:center'>1</span>
                                        勾选“2小时加急”选项，我们将在<span style='color:#FF7B00'>2小时</span>内缴纳罚款至银行。
                                    </p>
                                    <p style='text-align:left;padding-left:20px;margin-top:10px'>
                                        <span style='position:absolute;left:10px;margin-top:2px;color:#fff;line-height:15px;width:15px;height:15px;background:#D8D8D8;border-radius:50%;text-align:center'>2</span>
                                        未勾选“2小时加急”选项，我们将在<span style='color:#FF7B00'>24小时</span>内缴纳罚款至银行。
                                    </p>
                                    <i slot="reference" style="cursor:pointer;color:#0088FF;font-size:20px;line-height:40px;margin-left:10px" class="el-input__icon el-icon-question"></i>
                                </el-popover>
                            </el-form-item>
                        </el-form>
                        <div style="width:1px;background:#E6E6E6;margin:0 30px;"></div>
                        <el-form label-width="100px" class="payform" size="small">
                            <el-form-item label="罚款金额">
                                {{payForm&&payForm.money || 0}} 元
                            </el-form-item>
                            <el-form-item label="滞纳金">
                                {{ payForm&&payForm.late_free || 0 }} 元
                            </el-form-item>
                            <el-form-item label="服务费">
                                {{ payForm&&payForm.own_free || 0 }} 元
                            </el-form-item>
                            <el-form-item label="加急费" v-if="urge">
                                {{ Qfee || 0 }} 元
                            </el-form-item>
                            <el-form-item label="支付方式">
                                <el-radio v-model="payType" label="alipay">
                                    <img src="../assets/alilogo.png" style="width:20px;vertical-align: bottom;">
                                    支付宝
                                </el-radio>
                                <br/>
                                <el-radio v-model="payType" label="wechat_web">
                                    <img src="../assets/wxlogo.png" style="width:20px;vertical-align: bottom;">
                                    微信
                                </el-radio>
                            </el-form-item>
                            <!--  -->
                            <div class="attention-important" v-if="XcdNotice" style="margin-top:10px;" @click="handleShowNotice">
                                <img src="../assets/notice_icon.png" 
                                style="width:14px;height:14px;margin-right:5px;"/>
                                {{XcdNotice && XcdNotice.Title}} 公告按时发顺丰
                                <img src="../assets/notice_icon_right.png"
                                style="width:8px;height:12px;margin-left:10px;"/>
                            </div>
                        </el-form>
                    </div> 
                </div>
                <div style="text-align:center;margin:30px 0">
                    <el-button type="primary" style="width:200px" @click="GenerateOrders">确定处理</el-button>
                </div>
                <div style="color:#97A3B4;font-size:12px;text-align: center;">
                    注：交通违法代缴的办理周期为<span style="color:#002257">2-5个工作日</span>。现场单或已领处罚单决定书可直接交款，请须知！如有疑问，请参见<span style="color:#002257;cursor: pointer;" @click="gotoHelp">常见问题</span>。
                    <p style="margin-top:10px">我同意<span style="color:#002257;cursor: pointer;" @click="agreeModel = true">《服务条款》</span>中的说明。</p>
                </div>
            </el-card>
            <paydailog v-model="showpay" :totalPrice="totalPrice"  :paysrc="paysrc" :outTradeNo="out_trade_no" :payType="payType"></paydailog>
            <agree v-model="agreeModel"></agree>
            <help v-model="helpModel"></help>
        </div>
        
    </div>
</template>
<script>
    import payDailog from './component/PayDailog.vue'
    import agree from './component/Agree.vue'
    import help from './component/Help.vue'
    export default {
        components:{
            'paydailog': payDailog,
            'agree': agree,
            'help':help,
        },
        data(){
            return {
                orderNumber: this.$store.state.orderNumber || '',
                payForm:{},
                phone:'',
                payType: 'alipay',
                showpay:false,
                out_trade_no:'',
                timer:'',
                paysrc:'',
                agreeModel:false,
                UserTel: window.localStorage.UserTel || '',
                urge:false,
                canUrge: false,
                Qfee: 0,
                helpModel: false,
                showapp: false,
                XcdNotice: null
            }
        },
        computed:{
            totalPrice(){
                let price = Number(this.payForm.money * 100);
                let totalPrice = Math.round(price) + Math.round(this.payForm.own_free * 100) + Math.round(this.payForm.late_free * 100);
                if(this.urge) {
                    totalPrice = totalPrice + Math.round(this.Qfee* 100)
                }
                return totalPrice || 0
            }
        },
        mounted(){
            this.user = {
                Id: window.localStorage.UserId || '',
                Tel: window.localStorage.UserTel || window.UserTel || '',
                Icon: window.localStorage.UserIcon || window.UserIcon || '',
                Nick: window.localStorage.UserName || window.UserName || ''
            }
            this.phone = window.localStorage.UserTelAll
            if(this.$store.state.handFill && this.$store.state.handFill.price) {
                this.payForm = {
                    money: this.$store.state.handFill.price || '',
                    renfa_time: this.$store.state.handFill.date || '',
                    late_free: this.$store.state.handFill.lateFree || '',
                    own_free: this.$store.state.handFill.ownFree || '',
                    name: this.$store.state.handFill.nick,
                    car_no: this.$store.state.handFill.nickCarNo || '',
                    ticketUrl: this.$store.state.handFill.ticketUrl || '',
                    drive_no: this.$store.state.handFill.drive_no || '',
                }
            }else {
                // this.$router.push({
                //     path: '/pay',
                // })
            }
            this.getVioFee()
        },
        methods:{
            getNotice() {
                this.$request('v3/violation/view/notice').then((xhr, res) => {
                    if (res.code === 0 && res.data) {
                        if (res.data.XcdHave) {
                            this.XcdNotice = res.data.XcdNotice;
                        }
                    } else {
                        this.XcdNotice = null;
                    }
                }).catch(() => {
                    this.XcdNotice = null;
                });
            },
            handleShowNotice() {
                this.$alert(this.XcdNotice.Content, this.XcdNotice.Title, {
                    confirmButtonText: '我知道了',
                    callback: () => {
                        this.$router.push({
                            path: '/paying'
                        })
                    }
                });
            },
            urgeChange() {
                if(this.urge) {
                    if(!this.Qfee) {
                        this.getVioFee()
                    }
                }
            },
            // 常见问题
            gotoHelp() {
                this.helpModel = true
            },
            getVioFee() {
                let param = {
                    notice_num: this.orderNumber.replace(/\s/g,""),
                    fine: Number(this.payForm.money) * 100,
                    vio_time: this.payForm.renfa_time,
                }
                this.$request('v3/violation/fee', param).then((xhr, res) => {
                    if (res.code == 0) {
                        this.payForm.own_free = Number( res.data.OwnFree ? (res.data.OwnFree /100).toFixed(2) : 0);
                        this.payForm.late_free = Number(res.data.LateFree ? (res.data.LateFree /100).toFixed(2) : 0);
                        this.Qfee = Number(res.data.Qfee ? (res.data.Qfee /100).toFixed(2) : 0);
                        if(res.data && res.data.Quick == 1) {
                            this.canUrge = true
                        }
                    }
                    
                });
            },
            refill(){
                this.showNotice = true
                this.showForm2 = false
                this.showForm1 = false
                this.orderNumber = ''
                this.$store.state.orderNumber = ''
                this.$store.state.handFill = {
                    nick: '',
                    nickCarNo:'',
                    date:'',
                    ticketUrl: '',
                    price: '',
                    ownFree: 0,
                    lateFree:  0,
                    showForm1: false,
                    showForm2: false,
                    showNotice: true,
                    drive_no: false,
                }
                this.$router.replace({
                    path: '/pay'
                })
            },
            goback(){
                this.$router.replace({
                    path: '/pay'
                })
            },
            GenerateOrders() {
                let self = this
                let price = Number(this.payForm.money * 100);
                let totalPrice = Math.round(price) + Math.round(this.payForm.own_free * 100) + Math.round(this.payForm.late_free * 100);
                let param = {
                    formid: '',
                    fine: price, // 罚金
                    ownFree: this.payForm.own_free ? Math.round(this.payForm.own_free * 100) : 0, // 服务费
                    lateFree: this.payForm.late_free ? Math.round(this.payForm.late_free * 100) : 0, // 滞纳金
                    totalPrice: totalPrice, // 总金额
                    notice_num: this.orderNumber.replace(/\s/g,"") || '', // 文书号
                    vio_time: this.payForm.renfa_time ? this.payForm.renfa_time.slice(0,10) : '', // 文章时间：格式：2017-12-13
                    img_url: this.payForm.ticketUrl || '', // 罚单连接
                    carno: this.payForm.car_no ?  this.payForm.car_no : '',
                    mobile: this.phone ? this.phone : window.localStorage.UserTelAll,
                    name: this.payForm.name || '', // 罚款人
                    drive_no: this.payForm.drive_no || '',  // 驾驶证号
                    car_type: window.localStorage.car_type || ''
                }

                if(this.urge) {
                    param.urge = 1,
                    param.qfee = Math.round(this.Qfee * 100)
                    param.totalPrice = totalPrice + Math.round(this.Qfee * 100)
                }
                if(this.payType === 'wechat_web') {
                    param.pay_method ='wechat_web'
                }

                this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
                    if(res.code == 20022) {
                        self.$router.push({
                            path: '/pay',
                        })
                        return;
                    }
                    if (res.code >= 40000 && res.code < 50000) {
                        self.$router.push({
                            path: '/pay',
                        });
                        return;
                    }
                    if (res.code == 0) {
                        self.paysrc = this.payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img
                        self.out_trade_no = res.data.out_trade_no
                        self.showpay = true
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                // window.location.href = "https://mapi.alipay.com/gateway.do?_input_charset=utf-8&airticket=800%5E%E7%A5%A8%E9%9D%A2%E4%BB%B7%7C50%5E%E6%9C%BA%E5%BB%BA%E8%B4%B9%7C120%5E%E7%87%83%E6%B2%B9%E8%B4%B9%7C30%5E%E8%88%AA%E6%84%8F%E9%99%A9&extern_token=appopenBb64d181d0146481ab6a762c00714cC27&it_b_pay=3837m&notify_url=http%3A%2F%2Fhlcb.uz.com%2Fnotify-web%2FTradePayNotify&otherfee=200&out_trade_no=70501111111S001111119&partner=2088111111111194&payment_type=1&return_url=alipays%3A%2F%2Fplatformapi%2FstartApp%3FappId%3D10000011&seller_id=2088111111116894&service=alipay.wap.create.direct.pay.by.user&sign=AqDeHSqY%2BwcYy0bTSAaVoyTGTYOOkXm6KEKlJ6LIaefDOdX%2F3adfalkdfjaldkfjaldlGrkVJNqcL5Lf2%2BX2SGH4jPl9E5PbsAgFq0LQGT4kvhTdcOGqaOcjYRt3TScJnoFn%2B3biV3P2%2FiBuRTdVuOgivkkjG%2BNDLKTDAgTxDNM%3D&sign_type=RSA&subject=%e5%a4%a7%e4%b9%90%e9%80%8f&total_fee=9.00&show_url=http%3A%2F%2Fwww.taobao.com%2Fproduct%2F113714.html"
            },  
            // app(show){
            //     this.showapp = show
            // }
        }
    }
</script>
<style scoped>
.vio-header{
    line-height: 60px;
    /* border-bottom: 1px solid #EBEDF7;
    background: #fff; */
    display: flex;
    align-items: center;
    position: relative;
}


.pay-container{
    display: flex;
    
}
.form-title{
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    font-size: 12px;
}
.upload{
    box-sizing: border-box;
    width: 200px;
    height: 100px;
    display: flex;
    flex-direction: column;
    border: 1px solid #EBEDF7;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}
</style>



<style>
.payingForm .el-form-item{
    margin-bottom:8px !important;
}
</style>